import axios from "axios";
import { loadJSON, saveJSON } from "./jsonUtils";

const GOOGLE_DATA_URL = "/storage/googleData.json"; // Peut être une URL publique o2switch
const GOOGLE_API_URL =
  "https://places.googleapis.com/v1/places/ChIJ-x_JxzZw5kcRB081YdjRgTs?fields=reviews,displayName,reviews.authorAttribution,rating"; // Remplace avec ton endpoint Google Places API
const GOOGLE_API_KEY = "AIzaSyC8UGpKchr7VKvyWkmynfJuRVfHw4LjQDA";

const GOOGLE_JSON_FILE = "googleData";
const CACHE_DURATION = 12 * 60 * 60 * 1000; // 12h en ms

export async function getGoogleData() {
  try {
    const now = new Date();
    // Sinon, appel API Google
    const { data } = await axios.get(GOOGLE_API_URL, {
      params: {
        key: GOOGLE_API_KEY,
      },
      headers: {
        "Accept-Language": "fr-FR,fr;q=0.9,en;q=0.8",
      },
    });

    console.log("Données Google récupérées :", data);
    // Reformater les données selon ton usage
    const newGoogleData = {
      timestamp: now.toISOString(),
      globalRating: data.rating,
      reviews: data.reviews.slice(0, 10).map((r) => ({
        starRating: r?.rating,
        comment: r?.text?.text,
        reviewer: r?.authorAttribution?.displayName,
        updateTime: r?.relativePublishTimeDescription,
        publishDateTime: r?.publishTime,
      })),
    };

    return newGoogleData;
  } catch (error) {
    console.error("Erreur lors de la récupération des avis Google :", error);
    return null;
  }
}

export const fetchGoogleReviewsWithCache = async () => {
  console.log(
    "🔄 Chargement des avis Google avec cache... : " + GOOGLE_JSON_FILE
  );
  const cachedData = await loadJSON(GOOGLE_JSON_FILE);
  const now = Date.now();

  if (cachedData && now - cachedData.timestamp < CACHE_DURATION) {
    console.log("✅ Données Google chargées depuis le cache.");
    return cachedData;
  }

  console.log("🔄 Récupération des avis Google depuis l'API...");

  // 🔻 Simule ici ta récupération API ou JSON statique
  const response = await getGoogleData(); // ou API

  console.log("Données Google récupérées :", response);
  if (response === null) {
    console.error("❌ Erreur lors de la récupération des données Google.");
    return null;
  }

  const newData = {
    timestamp: now,
    globalRating: response.globalRating,
    reviews: response.reviews.slice(0, 10),
  };

  await saveJSON(GOOGLE_JSON_FILE, newData);
  return newData;
};
